export enum CypressUniqueNameType {
  AddPropertyButton = 'add-property-button',
  CreateWorkspaceButton = 'create-workspace-button',
  CreateWorkspaceFriendlyName = 'create-workspace-friendly-name',
  CreateWorkspaceFinalButton = 'create-workspace-final-button',
  DeleteResourceMenuButton = 'delete-resource-menu-button',
  ConfirmDeleteResourceButton = 'confirm-delete-resource-button',
  UserSettingsNickInput = 'user-settings-nick-input',
  DeleteWorkspaceButton = 'delete-workspace-button',
  ConfirmDeleteWorkspaceButton = 'confirm-delete-workspace-button',
  NotificationInput = 'notification-input',
  WorkspaceSettingsNameInput = 'workspace-settings-name-input',
  SaveSettingsButton = 'save-settings-button',
  AddResourceButton = 'add-resource-button',
  ResourceItemTitle = 'resource-item-title',
  PropertiesContainer = 'properties-container',
  PropertySearchInput = 'property-search-input',
  ChooseItemComponent = 'choose-item-component',
  ClosePropertyButtonComponent = 'close-property-button-component',
  AddPropertyTitleInput = 'add-property-title-input',
  AddPropertyButtonComponent = 'add-property-button-component',
  HeaderTable = 'header-table',
  AddItemUnderGroupButton = 'add-item-under-group-button',
  CellValue = 'cell-value',
  CellItemInput = 'cell-item-input',
  SaveDatabaseItemDraftButton = 'save-database-item-draft-button',
  SelectItemCheckbox = 'select-item-checkbox',
  CommandPanelContainer = 'command-panel-container',
  CommandPanelContainerHeader = 'command-panel-container-header',
  CommandPanelContainerDuplicate = 'command-panel-container-duplicate',
  CommandPanelContainerEdit = 'command-panel-container-edit',
  CommandPanelContainerClose = 'command-panel-container-close',
  CommandPanelContainerDelete = 'command-panel-container-delete',
  NotificationComponent = 'notification-component',
  NotificationButton ='notification-button',
  MessageCard = 'message-card',
  MessageAction = 'message-action',
  NotificationMessage ='notification-message',
  NotificationClose='notification-close',
  NotificationDescription = 'notification-description',
  AddItemHeaderButton = 'add-item-header-button',
  SelectSpaceComponent = 'select-space-component',
  SelectSpaceHeader = 'select-space-header',
  SelectSpaceItem = 'select-space-item-container',
  AddSpaceButton = 'add-space-button',
  SpaceOptionsButton = 'space-options-button',
  ContextMenuComponent = 'context-menu-component',
  MenuPosition = 'menu-position',
  SpaceInputComponent = 'space-input-component',
  HeaderHideButton ='header-hide-button',
  ModalHeaderComponent = 'modal-header-component',
  HidePropertiesComponent = 'hide-properties-component',
  DatabasePropertySettings = 'database-property-settings',
  SettingsPropertyContainer = 'settings-property-container',
  SettingsPropertyContainerTitle = 'settings-property-container-title',
  SettingsPropertyContainerIcons = 'settings-property-container-icons',
  CopyIcon = 'copy-icon',
  TextItemValue = 'text-item-value',
  DropdownComponentContent = 'dropdown-component-content',
  MarkdownEditorWrapper = 'markdown-editor-wrapper',
  ColumnSettingsPrefix = 'column-settings-prefix',
  ColumnSettingsSuffix = 'column-settings-suffix',
  NumberItemValue = 'number-item-value',
  ToggleComponent = 'toggle-component',
  PropertyActionSettings = 'property-action-settings',
  DatabasePropertyHeaderDropdownContentComponent = 'database-property-header-dropdown-content-component',
  ClearValueComponent = 'clear-value-component',
  PeopleNick = 'people-nick',
  AddEditStatusButton = 'add-edit-status-button',
  CreateNewStatusButton = 'create-new-status-button',
  StatusItem = 'status-item',
  StatusItemDelete = 'status-item-delete',
  StatusItemEdit = 'status-item-edit',
  StatusItemInput = 'status-item-input',
  StatusDropdownOkButton = 'status-dropdown-ok-button',
  StatusItemWrapper = 'status-item-wrapper',
  StatusItemEditButton = 'status-edit-button',
  StatusItemEditIcon = 'status-edit-icon',
  CalendarPicker = 'calendar-picker',
  CalendarPickerDay = 'calendar-picker-day',
  CalendarPickerDayToday= 'calendar-picker-day-today',
  CalendarPickerAddRange = 'calendar-picker-add-range',
  LinkInputModalHref = 'link-input-modal-href',
  LinkInputModalTitle = 'link-input-modal-title',
  LocationInput = 'location-input',
  NewChatMessageInput = 'new-chat-message-input',
  ConversationFillMiddleContainer = 'conversation-fill-middle-container',
  ConversationMessageWrapper = 'conversation-message-wrapper',
  ConversationMessageContent = 'conversation-message-content',
  ConversationMessageNick = 'conversation-message-nick',
  ConversationMessageDate = 'conversation-message-date',
  FloatingTooltipComponent = 'floating-tooltip-component',
  GroupByButton = 'group-by-button',
  GroupByAmount = 'group-by-amount',
  OptionsWrapper = 'options-wrapper',
  SidebarResourceItem = 'sidebar-resource-item',
  SidebarResourceItemIcon = 'sidebar-resource-item-icon',
  SidebarResourceItemDropdownButton = 'sidebar-resource-item-dropdown-button',
  ChoseViewType = 'chose-view-type',
  ChooseViewTypeComponent = 'choose-view-type-component',
  ViewType = 'view-type',
  TabComponent = 'tab-component',
  FilterButton = 'filter-button',
  FilterQueryButtonComponent = 'filter-query-button-component',
  FilterTextInput = 'filter-text-input',
  SearchInput = 'search-input',
  InputIcon = 'input-icon',
  FormCreationStart = 'form-creation-start',
  StartFromScratch = 'start-from-scratch',
  FromTableView = 'from-table-view',
  FromExistingView = 'from-existing-view',
  BrowseTemplatesResourceItem = 'browse-templates-resource-item',
  DatabasePageRoot = 'database-page-root',
  DatabaseTableRoot = 'database-table-root',
  DatabaseHtmlTableRoot = 'database-html-table-root',
  DatabaseCellEditor = 'database-cell-editor',
  DatabaseHeaderCell = 'database-header-cell',
  DatabaseRow = 'database-row',
  DatabaseRowCheckbox = 'database-row-checkbox',
  DatabaseCell = 'database-cell',
  FilterAddButton = 'filter-add-button',
  FilterRemoveButton = 'filter-remove-button',
  FilterOperatorSelect = 'filter-operator-select',
  FilterPropertyItem = 'filter-property-item',
  SortAddButton = 'sort-add-button',
  SortRemoveButton = 'sort-remove-button',
  HiddenPropertiesToggle = 'hidden-properties-toggle',
  PropertyTypeSelectorText = 'property-type-selector-text',
  PropertyTypeSelectorLongText = 'property-type-selector-long-text',
  PropertyTypeSelectorNumber = 'property-type-selector-number',
  PropertyTypeSelectorBoolean = 'property-type-selector-boolean',
  PropertyTypeSelectorDate = 'property-type-selector-date',
  PropertyTypeSelectorStatus = 'property-type-selector-status',
  PropertyTypeSelectorDropdown = 'property-type-selector-dropdown',
  PropertyTypeSelectorRelation = 'property-type-selector-relation',
  PropertyTypeSelectorFormula = 'property-type-selector-formula',
  PropertyTypeSelectorPeople = 'property-type-selector-people',
  PropertyTypeSelectorFiles = 'property-type-selector-files',
  PropertyTypeSelectorChecklist = 'property-type-selector-checklist',
  PropertyTypeSelectorRating = 'property-type-selector-rating',
  LoginEmailInput = 'login-email-input',
  LoginPasswordInput = 'login-password-input',
  LoginSignInButton = 'login-sign-in-button',
  RegisterEmailInput = 'register-email-input',
  RegisterNameInput = 'register-name-input',
  RegisterPasswordInput = 'register-password-input',
  RegisterButton = 'register-button',
  UserNick = 'user-nick',
  CreateWorkspaceUrlNameInput = 'create-workspace-url-name-input',
  CurrentWorkspaceName = 'current-workspace-name',
  SidebarResourceItemRenameInput = 'sidebar-resource-item-rename-input',
  TemplateSidebarCategory = 'template-sidebar-category',
  TemplateCard = 'template-card',
  TemplateUseButton = 'template-use-button',
  TemplateRailItem = 'template-rail-item',
  TemplateRailItemCheck = 'template-rail-item-check',
  CreateResourceModeTab = 'create-resource-mode-tab',
  ResourceTypeItem = 'resource-type-item',
  DatabaseViewSettingsButton = 'database-view-settings-button',
  KanbanSettingsSidebarTitle = 'kanban-settings-sidebar-title',
  KanbanColorizeCardsSetting = 'kanban-colorize-cards-setting',
  SidebarDatabaseViewItem = 'sidebar-database-view-item',
  SidebarDatabaseViewItemDropdownButton = 'sidebar-database-view-item-dropdown-button',
  SidebarDatabaseViewItemRenameInput = 'sidebar-database-view-item-rename-input',
  RenameDatabaseViewMenuButton = 'rename-database-view-menu-button',
  DocumentStatusChip = 'document-status-chip',
  DocumentTitleInput = 'document-title-input',
  DocumentEditorContent = 'document-editor-content',
  DocumentRemoteUser = 'document-remote-user',
  SkillNameText = 'skill-name-text',
  SkillNameEditButton = 'skill-name-edit-button',
  SkillNameInput = 'skill-name-input',
  SkillNameError = 'skill-name-error',
  SkillVersionBadge = 'skill-version-badge',
  SkillSaveButton = 'skill-save-button',
  SkillPublishButton = 'skill-publish-button',
  SkillTitleInput = 'skill-title-input',
  SkillDescriptionInput = 'skill-description-input',
  SkillTag = 'skill-tag',
  SkillTagRemoveButton = 'skill-tag-remove-button',
  SkillTagInput = 'skill-tag-input',
  SkillPublishChangelogInput = 'skill-publish-changelog-input',
  SkillPublishConfirmButton = 'skill-publish-confirm-button',
  AgentVersionBadge = 'agent-version-badge',
  AgentSaveButton = 'agent-save-button',
  AgentPublishButton = 'agent-publish-button',
  AgentTitleInput = 'agent-title-input',
  AgentDescriptionInput = 'agent-description-input',
  AgentTag = 'agent-tag',
  AgentTagRemoveButton = 'agent-tag-remove-button',
  AgentTagInput = 'agent-tag-input',
  AgentChangelogInput = 'agent-changelog-input',
  AgentPublishConfirmButton = 'agent-publish-confirm-button',
  AgentAttachSection = 'agent-attach-section',
  AgentAttachItem = 'agent-attach-item',
  AgentAttachRemoveButton = 'agent-attach-remove-button',
  AgentAttachSearchInput = 'agent-attach-search-input',
  AgentAttachSuggestion = 'agent-attach-suggestion',
  AgentCronItem = 'agent-cron-item',
  AgentCronRemoveButton = 'agent-cron-remove-button',
  AgentCronTaskPromptInput = 'agent-cron-task-prompt-input',
  AgentCronAddButton = 'agent-cron-add-button',
  AgentRunsEmpty = 'agent-runs-empty',
  CronPickerValue = 'cron-picker-value',
  CronPickerOption = 'cron-picker-option',
  WhiteboardToolButton = 'whiteboard-tool-button',
  WhiteboardTemplatesButton = 'whiteboard-templates-button',
  WhiteboardUndoButton = 'whiteboard-undo-button',
  WhiteboardRedoButton = 'whiteboard-redo-button',
  WhiteboardSurface = 'whiteboard-surface',
  WhiteboardTextEditor = 'whiteboard-text-editor',
}
